/* unplugin-vue-components disabled */import { render } from "./postCard.vue?vue&type=template&id=115d4488&scoped=true"
import script from "./postCard.vue?vue&type=script&lang=js"
export * from "./postCard.vue?vue&type=script&lang=js"

import "./postCard.vue?vue&type=style&index=0&id=115d4488&scoped=true&lang=css"

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115d4488"]])

export default __exports__